/* MIKOO cart: the free-shipping bar fills from where it was, and a "complete the wall" suggestion
   for single prints that belong to a gallery wall. Dawn redraws the cart drawer and cart page after
   every change, so this re-applies itself to the new markup. */
(function () {
  var lastProgress = null;
  var mapPromise = null;
  var productCache = {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

  /* ---------- free-shipping bar ---------- */
  function animateBars() {
    document.querySelectorAll('.mk-ship:not([data-mk-done])').forEach(function (bar) {
      bar.setAttribute('data-mk-done', '');
      var fill = bar.querySelector('.mk-ship__fill');
      var target = Math.min(1, (parseInt(bar.dataset.progress, 10) || 0) / 1000);
      var from = lastProgress == null ? 0 : lastProgress;
      /* start from the old value with no transition, then let it travel to the new one */
      fill.style.transition = 'none';
      fill.style.transform = 'scaleX(' + from + ')';
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.transform = 'scaleX(' + target + ')';
      bar.classList.toggle('is-complete', target >= 1);
      /* crossing the free-delivery line is a small win: the new line rises in, once */
      if (target >= 1 && lastProgress != null && lastProgress < 1 && !reduceMotion) {
        var text = bar.querySelector('.mk-ship__text');
        if (text && text.animate) text.animate([{ opacity: 0, transform: 'translateY(0.6rem)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: 300, easing: EASE, fill: 'backwards' });
      }
      lastProgress = target;
    });
  }

  /* ---------- complete the wall ---------- */
  function setMap() {
    var box = document.querySelector('.mk-upsell');
    if (!box) return null;
    if (!mapPromise) {
      mapPromise = fetch(box.dataset.map).then(function (r) { return r.json(); }).then(function (singleToSets) {
        /* invert once: set -> its single prints */
        var setToSingles = {};
        Object.keys(singleToSets).forEach(function (single) {
          singleToSets[single].forEach(function (set) { (setToSingles[set] = setToSingles[set] || []).push(single); });
        });
        return { singleToSets: singleToSets, setToSingles: setToSingles };
      }).catch(function () { return null; });
    }
    return mapPromise;
  }

  function product(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return productCache[handle];
  }

  function money(cents) {
    var value = cents / 100;
    return '₪' + (value % 1 === 0 ? value.toLocaleString('he-IL') : value.toLocaleString('he-IL', { minimumFractionDigits: 2 }));
  }

  function fillUpsell() {
    var box = document.querySelector('.mk-upsell:not([data-mk-done])');
    if (!box) return;
    box.setAttribute('data-mk-done', '');
    var inCart = (box.dataset.handles || '').split(',').filter(Boolean);
    if (!inCart.length) return;
    var maps = setMap();
    if (!maps) return;
    maps.then(function (m) {
      if (!m) return;
      /* the first single in the cart that belongs to a wall: suggest another print from that wall */
      for (var i = 0; i < inCart.length; i++) {
        var sets = m.singleToSets[inCart[i]] || [];
        for (var j = 0; j < sets.length; j++) {
          /* skip what is already in the cart, and size-specific copies of it (e.g. "<handle>-frame-50x70") */
          var partners = (m.setToSingles[sets[j]] || []).filter(function (h) {
            return !inCart.some(function (c) { return h === c || h.indexOf(c + '-') === 0 || c.indexOf(h + '-') === 0; });
          });
          if (partners.length) return partners[0];
        }
      }
      return null;
    }).then(function (handle) {
      return handle ? product(handle) : null;
    }).then(function (p) {
      if (!p || !document.body.contains(box)) return;
      var img = p.media && p.media[1] ? p.media[1].src : p.featured_image; /* the room mock-up when there is one */
      box.innerHTML =
        '<p class="mk-upsell__title">השלימו את הקיר</p>' +
        '<a class="mk-upsell__card" href="' + p.url + '">' +
        '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">' +
        '<span class="mk-upsell__info"><span class="mk-upsell__name"></span>' +
        '<span class="mk-upsell__price">החל מ-' + money(p.price_min) + '</span>' +
        '<span class="mk-upsell__go">לצפייה ‹</span></span></a>';
      box.querySelector('.mk-upsell__name').textContent = p.title + ' – מאותו קיר גלריה';
      /* the empty frame on the drawn wall leads to the same picture */
      var plus = document.querySelector('.mk-cwall__plus');
      if (plus) plus.setAttribute('href', p.url);
      box.hidden = false;
    });
  }


  /* ---------- the wall being built (drawer) ---------- */
  /* The pictures in the cart, drawn to scale on a wall above a 2 m sofa, each in its frame; an empty "+" frame
     leads to the "complete the wall" suggestion (or the best sellers). Sizes and frames come from the line's
     options; a set brings all its pictures. Unframed pictures by file name, the same rule as mikoo-frame.js.
     Frame colours: keep in sync with mikoo-frame.js. */
  var FRAME_COLOURS = { 'עץ שחור': '#121214', 'עץ טבעי': '#e6c88f', 'עץ מולבן': '#f1e8d9', 'עץ אלון': '#bfa074', 'אלומיניום שחור': '#0c0c0e', 'אלומיניום לבן': '#efefef' };
  /* wood frames: drawn a little thicker than aluminium (1.5 cm against 0.7), with real grain where it shows
     (the same frame pictures as the product page, CSS in mikoo-theme.css; black wood stays plain) */
  var FRAME_TEX = { 'עץ שחור': 'black', 'עץ טבעי': 'natural', 'עץ מולבן': 'whitewashed', 'עץ אלון': 'oak' };
  var WALL_GAP_CM = 8;
  function stemOf(src) {
    var m = /([^/]+)[.](jpe?g|png|webp)$/i.exec(String(src || '').split('?')[0]);
    return m ? m[1].replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '').replace(/_[0-9]+$/, '') : null;
  }
  function plainImages(p) {
    var media = (p.media || []).filter(function (m) { return m.media_type === 'image'; });
    var stems = media.map(function (m) { return stemOf(m.src); }).filter(Boolean);
    var ones = stems.filter(function (x) { return /1$/.test(x); });
    var bases = stems.filter(function (x) { return /2$/.test(x); }).map(function (x) { return x.slice(0, -1); });
    var keep = ones.filter(function (x) { return bases.indexOf(x.slice(0, -1)) > -1; });
    if (!keep.length) keep = ones;
    if (!keep.length) keep = stems.filter(function (x) { return !/[0-9]$/.test(x) && stems.indexOf(x + '2') > -1; });
    var out = media.filter(function (m) { return keep.indexOf(stemOf(m.src)) > -1; });
    return out.length ? out : (p.featured_image ? [{ src: p.featured_image, width: 3, height: 4 }] : []);
  }
  function drawWall() {
    var box = document.querySelector('.mk-cwall');
    if (!box || box.dataset.mkDone) return;
    box.dataset.mkDone = '1';
    var lines;
    try { lines = JSON.parse(box.dataset.lines || '[]'); } catch (e) { return; }
    if (!lines.length) return;
    Promise.all(lines.map(function (l) { return product(l.h); })).then(function (products) {
      if (!document.body.contains(box)) return;
      var pics = [];
      lines.forEach(function (l, i) {
        var p = products[i];
        if (!p) return;
        var size = null, frame = null, pairs = null;
        (l.o || []).forEach(function (v) {
          var m = /^([0-9]+) *[xX] *([0-9]+)$/.exec(String(v).trim());
          if (m) size = [+m[1], +m[2]];
          /* size pairs such as "70x70 + 50x70": each picture takes the size closest to its own shape (mikoo-frame.js comboSizes) */
          var parts = String(v).split('+').map(function (s) { return /^\s*([0-9]+)\s*[xX×]\s*([0-9]+)\s*$/.exec(s); });
          if (parts.length > 1 && parts.every(Boolean)) pairs = parts.map(function (x) { return { w: +x[1], h: +x[2] }; });
          if (FRAME_COLOURS[v]) frame = v;
          if (String(v).indexOf('ללא מסגרת') > -1) frame = 'none';
        });
        var imgs = plainImages(p);
        var copies = l.set ? 1 : Math.min(l.q, 3);
        for (var c = 0; c < copies; c++) {
          var left = pairs ? pairs.slice() : null;
          imgs.forEach(function (m) {
            var land = m.width > m.height * 1.05;
            var s = size || [30, 40];
            if (left && left.length) {
              var r = m.width && m.height ? m.width / m.height : 0.75, k = 0;
              left.forEach(function (x, j) { if (Math.abs(Math.log(r / (x.w / x.h))) < Math.abs(Math.log(r / (left[k].w / left[k].h)))) k = j; });
              var pick = left.splice(k, 1)[0];
              pics.push({ src: m.src, w: pick.w, h: pick.h, frame: frame });
              return;
            }
            var w = land ? Math.max(s[0], s[1]) : Math.min(s[0], s[1]);
            var h = land ? Math.min(s[0], s[1]) : Math.max(s[0], s[1]);
            pics.push({ src: m.src, w: w, h: h, frame: frame });
          });
        }
      });
      pics = pics.slice(0, 8);
      if (!pics.length) return;
      var total = pics.reduce(function (a, p) { return a + p.w; }, 0) + WALL_GAP_CM * (pics.length - 1);
      var span = Math.max(220, total + 40); /* the wall shown is at least as wide as the sofa and a little more */
      var tallest = Math.max.apply(null, pics.map(function (p) { return p.h; }));
      var upsell = document.querySelector('.mk-upsell .mk-upsell__card');
      var plusHref = upsell ? upsell.getAttribute('href') : '/collections/הנמכרים-ביותר';
      var plusW = pics[pics.length - 1].w, plusH = pics[pics.length - 1].h;
      var pct = function (cm) { return (cm / span * 100).toFixed(2) + '%'; };
      var html = '<div class="mk-cwall__wall" style="--mk-span:' + span + ';--mk-tall:' + tallest + '">' + '<div class="mk-cwall__row">';
      pics.forEach(function (p) {
        var colour = p.frame && p.frame !== 'none' ? FRAME_COLOURS[p.frame] : null;
        html += '<span class="mk-cwall__pic' + (colour ? '' : ' is-bare') + '"' + (colour && FRAME_TEX[p.frame] ? ' data-mk-tex="' + FRAME_TEX[p.frame] + '"' : '') + ' style="width:' + pct(p.w) + ';aspect-ratio:' + p.w + '/' + p.h + (colour ? ';--mk-fc:' + colour : '') + '">' +
          '<img src="' + p.src + (p.src.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy"></span>';
      });
      html += '<a class="mk-cwall__plus" href="' + plusHref + '" style="width:' + pct(plusW) + ';aspect-ratio:' + plusW + '/' + plusH + '" aria-label="תמונה שמשלימה את הקיר"><span aria-hidden="true">+</span></a>';
      html += '</div><svg class="mk-cwall__sofa" style="width:' + pct(200) + '" viewBox="0 0 200 52" aria-hidden="true" focusable="false"><rect x="6" y="14" width="188" height="26" rx="6"/><rect x="16" y="2" width="82" height="20" rx="4"/><rect x="102" y="2" width="82" height="20" rx="4"/><rect x="24" y="40" width="3" height="10"/><rect x="173" y="40" width="3" height="10"/></svg></div>';
      var count = pics.length;
      html += '<p class="mk-cwall__cap"><span>' + (count === 1 ? 'תמונה אחת' : count + ' תמונות') + ' על הקיר</span><span>רוחב כולל כ-' + Math.round(total) + ' ס״מ</span></p>';
      box.innerHTML = html;
      box.hidden = false;
    });
  }

  /* ---------- cart lines: what was just added lights up, what was removed leaves without a jump ---------- */
  /* Lines have no key in Dawn's markup; the product link (with ?variant=) tells them apart. */
  var LISTS = 'cart-drawer-items, cart-items';
  var snapshots = {};   /* list tag -> { key: quantity } */
  var flip = null;      /* { time, tops: { key: top } } recorded on a remove / quantity press */

  function lineKey(row) {
    var link = row.querySelector('.cart-item__name');
    return link ? link.getAttribute('href') : null;
  }
  function lineQty(row) {
    var input = row.querySelector('.quantity__input');
    return input ? parseInt(input.value, 10) || 0 : 0;
  }
  function readLines(list) {
    var lines = {};
    list.querySelectorAll('.cart-item').forEach(function (row) {
      var key = lineKey(row);
      if (key) lines[key] = { row: row, qty: lineQty(row) };
    });
    return lines;
  }

  function animateLines() {
    var flipNow = flip && Date.now() - flip.time < 4000 ? flip : null;
    document.querySelectorAll(LISTS).forEach(function (list) {
      var tag = list.tagName;
      var lines = readLines(list);
      var before = snapshots[tag];
      var after = {};
      Object.keys(lines).forEach(function (key) {
        var line = lines[key];
        after[key] = line.qty;
        if (line.row.dataset.mkSeen) return; /* same element as last time: nothing was redrawn */
        line.row.dataset.mkSeen = '1';
        if (!line.row.animate) return;
        if (before && (!(key in before) || line.qty > before[key])) {
          /* new or more of it: a soft stone glow that fades, and a short rise when it is new */
          line.row.animate([{ backgroundColor: 'rgba(18, 18, 20, 0.07)' }, { backgroundColor: 'rgba(18, 18, 20, 0)' }], { duration: 1400, easing: 'ease-out' });
          if (!(key in before) && !reduceMotion) {
            line.row.animate([{ opacity: 0, transform: 'translateY(0.8rem)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: EASE });
          }
        } else if (flipNow && key in flipNow.tops && !reduceMotion) {
          /* the lines that stay glide from where they were to their new place */
          var delta = flipNow.tops[key] - line.row.getBoundingClientRect().top;
          if (Math.abs(delta) > 1) line.row.animate([{ transform: 'translateY(' + delta + 'px)' }, { transform: 'none' }], { duration: 300, easing: EASE });
        }
      });
      snapshots[tag] = after;
    });
    if (flipNow) flip = null;
  }

  /* feedback on the press: the line dims at once, before the cart answers */
  function onCartPress(event) {
    var button = event.target.closest && event.target.closest('cart-remove-button, .quantity__button');
    if (!button) return;
    var row = button.closest('.cart-item');
    var list = button.closest(LISTS);
    if (!row || !list) return;
    var tops = {};
    list.querySelectorAll('.cart-item').forEach(function (r) { var k = lineKey(r); if (k) tops[k] = r.getBoundingClientRect().top; });
    flip = { time: Date.now(), tops: tops };
    if (button.matches('cart-remove-button')) {
      row.style.transition = 'opacity 120ms ease-out';
      row.style.opacity = '0.35';
    }
  }

  /* the total crossfades when it changes */
  var lastTotals = {};
  function animateTotals() {
    document.querySelectorAll('.totals__total-value').forEach(function (el, i) {
      var text = el.textContent.trim();
      var id = el.closest('cart-drawer') ? 'drawer' : 'page' + i;
      if (lastTotals[id] != null && lastTotals[id] !== text && el.animate && !el.dataset.mkSeen) {
        el.animate([{ opacity: 0.2 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
      }
      el.dataset.mkSeen = '1';
      lastTotals[id] = text;
    });
  }

  function apply() {
    animateBars();
    animateLines();
    animateTotals();
    fillUpsell();
    drawWall();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; apply(); }, 0);
  }

  function init() {
    apply();
    document.addEventListener('click', onCartPress, true);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
